import { render } from "./yzPage.vue?vue&type=template&id=27527759"
import script from "./yzPage.vue?vue&type=script&lang=js"
export * from "./yzPage.vue?vue&type=script&lang=js"

import "./yzPage.vue?vue&type=style&index=0&id=27527759&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__